import styled from 'styled-components'

import { Colors } from '~/styles'

const EmptyDataContainer = styled.div`
  width: 100%;
  height: calc(100vh - 187px);
  display: flex;
  justify-content: center;
  align-items: center;
`

const EmptyDataContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`

const EmptyDataImage = styled.img`
  width: 30%;
  height: auto;
`

const EmptyDataText = styled.p`
  color: ${Colors.cancelTextColor};
  font-size: 28px;
  margin-top: 40px;
  font-weight: 500;
  margin-bottom: 0;
`

export default {
  EmptyDataText,
  EmptyDataImage,
  EmptyDataContent,
  EmptyDataContainer,
}